// src/components/Testimonials.jsx
import React, { useState } from "react";
import "./Testimonials.css";

const testimonialsData = [
  {
    name: "Aabhash Ghimire",
    img: "./Testimonial Aabhash Ghimire.jpg",
    alt: "Testimonial1",
    text: `I have had the pleasure of learning valuable lessons about counselling and psychotherapy from Ganesh sir. As a student of counselling psychology, I got to experience first-hand about various aspects of counselling, tools and techniques during the class. Outside the class, Ganesh sir is also my mentor for healthy and reflective living, yoga and self-care. As a participant of 'Nourish to Flourish: a self-care workshop' organized by Nirvana Psychosocial Care Center & Research Institute, I have thoroughly enjoyed being more mindful of my patterns and recognize their functions in my life. It was indeed very introspective. Whether it is counselling, dance movement therapy, training sessions in psychology, I look forward to receiving guidance and opportunity to work together in future.Thank you so much.`
  },
  {
    name: "Aarjue Basnet",
    img: "./Testimonial Aarjue Basnet.jpg",
    alt: "Testimonial2",
    imgStyle: { objectPosition: "0px -15px" },
    text: `Having had the privilege of learning from and working alongside Sir, Ganesh Amgain, I can confidently say that he is one of the most dedicated, ethical, and inspiring individuals I have ever met. As a teacher of Counseling Psychology, he brings not only a wealth of knowledge but also an unwavering commitment to our growth and well-being. \n\nI’ve also had the opportunity to attend the Self-care workshop at his center Nirvana Psychosocial Care Center & Research Institute, where his facilitation has helped me reconnect with myself on a deeper level. His empathy and genuine desire to see his students flourish is truly rare. In his Yoga Teacher's Training at Nirvana Yogalaya, I have found a space where I feel seen, challenged, and deeply encouraged to realize my full potential.\n\nWitnessing his work in sound healing  was another profound experience, his talent and presence are truly remarkable. Whether in a classroom, a yoga studio, or a healing space, he carries a quiet strength and integrity that leaves a lasting impact.\n\nI am grateful to have found not only a teacher but a mentor whose values, professionalism, and humanity I deeply admire and respect.`
  },
  {
    name: "Shrijana Yogmala Mainali",
    img: "./Testimonial Shrijana Yogmala Mainali.jpg",
    alt: "Testimonial3",
    text: `I joined Ganesh Sir’s Yoga Teacher’s Training at Nirvana Yogalaya. It was indeed transformative for me. His support greatly improved my flexibility & strength. His yog classes are not just yog asanas but also yog anatomy and philosophy, pranayama and meditation techniques which has helped me to be better yog teacher today. I have learnt to listen to my body, quiet my mind and connect with something greater than myself. I indeed have found my spiritual true self and I am very thankful to him for supporting me in this journey.`
  },
  {
    name: "Sarala Tiwari",
    img: "./testimonial Sarala Tiwari1.jpg",
    alt: "Testimonial4",
    text: `I had experienced severe traumas like my brother being brutally murdered, my mother shot in front of my eyes, my house burnt during Maoist war, being raped by one of the family members and so on. The complex traumas clearly showcased in my relationship dynamics as adult. I failed to form any kind of meaningful relationships and I ended having no friends, indeed none I could really bond with. In 2017, visited a few counsellors knowing that I needed help. But counsellors unintentionally had opened my rotten wound but had no idea how to heal or seal it safely.\n\nMeeting Ganesh Amgain at Nirvana Psychosocial Care Center & Research Institute, I started o see the layers of my difficult emotions peeling off. I could see the organic me over a few clouds of fear and pain. Turns out, once a week session, helped me to connect with myself. Within a year, I felt like the 12-year-old girl who had stopped living. My counselling sessions with Ganesh gave me a re-start. I turned 17 later that year and 23 and 26 again. It is the most beautiful journey I have ever witnessed. Within 1.5 years, I had a job for 1 year (BIG DEAL FOR ME), had a best friend, and could survive without harmful relationships.\n\nI am thankful to Nirvana and Ganesh because he did not help me solve all my life problems but definitely helped me introduce myself and taught me some vital skills to recognize my own emotions and my patterns. I would not have found myself without counselling sessions. I am now in the USA looking to pursue my master's in Trauma Counselling.For those who are in pain right now, I would say it's painful because there’s inside of you. Let somebody good help you release the pain and you will see yourself. `
  }
];

const MAX_LENGTH = 240;

const Testimonials = () => {
  const [expanded, setExpanded] = useState(Array(testimonialsData.length).fill(false));

  const handleToggle = idx => {
    setExpanded(expanded =>
      expanded.map((val, i) => (i === idx ? !val : val))
    );
  };


  return (
    <section id="testimonials" className="testimonials-section">
      <h2>Client Testimonials</h2>
      <div className="testimonial-list">
        {testimonialsData.map((testimonial, idx) => (
          <div className="testimonial-card" key={idx}>
            <img
              src={testimonial.img}
              className="testimonial-img"
              alt={testimonial.alt}
              style={testimonial.imgStyle}
            />
            <div>
              <p className="testimonial-name">{testimonial.name}</p>
              <div className="testimonial-text">
                {(
                  testimonial.text.length > MAX_LENGTH && !expanded[idx]
                    ? testimonial.text.slice(0, MAX_LENGTH) + "..."
                    : testimonial.text
                )
                  .split("\n\n")
                  .map((para, i) => (
                    <p key={i} style={{ margin: 0 }}>
                      {para}
                    </p>
                  ))}
                {testimonial.text.length > MAX_LENGTH && (
                  <span
                    className="see-more"
                    style={{ color: "#007bff", cursor: "pointer", marginLeft: 8 }}
                    onClick={() => handleToggle(idx)}
                  >
                    {expanded[idx] ? "See Less" : "See More"}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
